var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, CircularProgress } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
var defaultSettingsValues = {
    loaded: false,
    globalSettings: {
        QUERY_POLL_INTERVAL_MS: 3000,
        QUERY_FAST_POLL_INTERVAL_MS: 5000,
        DEFAULT_TENANT_ID: "90505c8a-23a9-4cdf-a26b-4e19f6a097d5",
        ONLINE_VOTING_CLIENT_ID: "admin-portal",
        KEYCLOAK_URL: "http://127.0.0.1:8090/",
        HASURA_URL: "http://localhost:8080/v1/graphql",
        APP_VERSION: "-",
        APP_HASH: "-",
        DEFAULT_EMAIL_SUBJECT: { en: "Participate in {{election_event.name}}" },
        DEFAULT_EMAIL_HTML_BODY: {
            en: "<p>Hello {{user.first_name}},<br><br>Enter in {{vote_url}} to vote</p>",
        },
        DEFAULT_EMAIL_PLAINTEXT_BODY: {
            en: "Hello {{user.first_name}},\n\nEnter in {{vote_url}} to vote",
        },
        DEFAULT_SMS_MESSAGE: {
            en: "Enter in {{vote_url}} to vote",
        },
        DEFAULT_DOCUMENT: {
            en: "<div>\n  {{{data.logo}}}\n</div>\n<div>\n  <h2>Your vote has been cast</h2>\n  <p>\n    The confirmation code bellow verifies that your ballot has been cast\n    successfully. You can use this code to verify that your ballot has been\n    counted.\n  </p>\n  <div class=\"info\">\n    <p>\n      Your Ballot ID:\n      <span class=\"id-content\">{{data.ballot_id}}</span>\n    </p>\n    <p>\n      Ballot tracker link:\n      <a href=\"{{data.ballot_tracker_url}}\">Click here</a>\n    </p>\n  </div>\n</div>\n\n<div>\n  <h2>Verify that your ballot has been cast</h2>\n  <p>\n    You can verify your ballot has been cast correctly at any moment using the\n    following QR code:\n  </p>\n  {{{data.qrcode}}}\n</div>",
        },
        PUBLIC_BUCKET_URL: "http://127.0.0.1:9002/public/",
        VOTING_PORTAL_URL: "http://localhost:3000",
        ACTIVATE_MIRU_EXPORT: false,
        CUSTOM_URLS_DOMAIN_NAME: "google.com",
    },
};
export var SettingsContext = createContext(defaultSettingsValues);
var SettingsContextProvider = function (props) {
    var _a = useState(false), loaded = _a[0], setLoaded = _a[1];
    var _b = useState(defaultSettingsValues.globalSettings), globalSettings = _b[0], setSettings = _b[1];
    var loadSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var value, json, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("/global-settings.json")];
                case 1:
                    value = _a.sent();
                    return [4 /*yield*/, value.json()];
                case 2:
                    json = _a.sent();
                    setSettings(Object.assign({}, defaultSettingsValues.globalSettings, json));
                    setLoaded(true);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log("Error loading settings: ".concat(e_1));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!loaded) {
            loadSettings();
        }
    }, [loaded]);
    // Setup the context provider
    return (_jsx(SettingsContext.Provider, __assign({ value: {
            loaded: loaded,
            globalSettings: globalSettings,
        } }, { children: props.children })));
};
var StyledBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    margin: auto;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    margin: auto;\n    align-items: center;\n    justify-content: center;\n"])));
export var SettingsGate = function (_a) {
    var children = _a.children;
    var loaded = useContext(SettingsContext).loaded;
    return loaded ? (_jsx(_Fragment, { children: children })) : (_jsx(StyledBox, { children: _jsx(CircularProgress, {}) }));
};
export var SettingsWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(SettingsContextProvider, { children: _jsx(SettingsGate, { children: children }) }));
};
var templateObject_1;
